import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Typography } from "@reconvert/react-ui-component";
import { useTranslation } from "react-i18next";
import Lottie from "lottie-react";
//@ts-ignore
import ReConvertLoading from "../../../assets/gif/ReConvert-Loading.json";

const Loading = () => {
  const { t } = useTranslation();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <Box w="100vw" h="100vh" display="flex" flexDir="column" justifyContent="center" alignItems="center">
      <Lottie animationData={ReConvertLoading} loop={true} autoplay={true} style={{ width: "180px" }} />
      {isLoaded && (
        <Typography variant="h5-medium">
          {t("Upsell.com magic is on it's way!")}
        </Typography>
      )}
    </Box>
  );
};

export default Loading;
